import styled from 'styled-components'
import {
  Box,
  Card,
  Container,
  Divider,
  Flex,
  Hide,
  Text
} from 'pcln-design-system'
import { themeGet } from '@styled-system/theme-get'
import { Gpt } from '@pcln/ad-unit'
import Content from '../Content'
import HeroImageParallax from '../../Heros/HeroImageParallax'
import PackagesSearchForm from '../SearchForm/Form'
import { onSubmit } from '../SearchForm/utils'

const BlockFlex = styled(Box)`
  position: relative;
  z-index: 1;
  ${themeGet('mediaQueries.xxl')} {
    display: flex;
  }
`

const HideAdUnit = styled(Hide)`
  flex: none;
  text-align: center;
  position: relative;
  margin: 16px;
  min-height: 90px;
  ${themeGet('mediaQueries.xxl')} {
    width: 300px;
    margin: 0 16px 0 16px;
  }
`

const footerText =
  'Save up to $625 when you book your hotel and flight together!'

function Desktop() {
  return (
    <Box data-testid="packages-desktop">
      <HeroImageParallax
        isScrollable
        gptId="div-gpt-ad-1511925223449-0"
        slot="/3102/priceline.dart/vp_homepage_hero_image"
        data-testid="pcln-hero-image-parallax"
        mb={4}
      >
        <Container maxWidth={1280}>
          <BlockFlex mx={3} py={[3, null, null, null, 5]} pb={3}>
            <Card
              borderWidth={0}
              color="background.lightest"
              borderRadius="2xl"
              boxShadowSize="xl"
              width={1}
            >
              <Box p={3}>
                <PackagesSearchForm onSubmit={onSubmit} pageName="landing" />
              </Box>
              <Divider my={0} borderColor="border.base" />
              <Flex
                p={3}
                borderRadius="2xl"
                boxShadowSize="xl"
                rounded="bottom"
                color="background.light"
                justifyContent="center"
              >
                <Text fontSize={1} textAlign="center" color="text.dark">
                  {footerText}
                </Text>
              </Flex>
            </Card>

            <HideAdUnit xs sm>
              <Gpt render={() => <div id="div-gpt-ad-1511925695047-0" />} />
            </HideAdUnit>
          </BlockFlex>
        </Container>
      </HeroImageParallax>
      <Hide xs sm color="background.lightest">
        <Content />
      </Hide>
    </Box>
  )
}

export default Desktop
